"use client";

import { ReportParentContentEnum } from "@/app/types/typeConfig/report";
import { IMConfigTypeEnum } from "@/app/types/typeConfig/chatQuestion";
import { useTranslations } from "@/app/lib/LocaleProvider";
import { AIFooter } from "@/app/components/robot/components/AIFooterShared";
import { Feedback } from "@/app/store/types";
interface FeedFooterProps {
  extension?: string;
  feedback?: Feedback;
  uniqueKey?: string;
  data: {
    parentContentInfo?: {
      parentContentId?: string;
      parentContent?: string;
      parentContentType?: ReportParentContentEnum;
    };
    [key: string]: unknown;
  };
  requestId?: string;
  content?: string;
  streamingId?: string;
  onStop?: () => void;
  onRedo?: () => void;
  onLike?: () => void;
  onDislike?: () => void;
}

/**
 * AI 消息底部栏（Feed）：统一使用 AIFooter，仅传入 Feed 场景的 config 与文案。
 */
export default function FeedFooter({
  data,
  requestId,
  content,
  streamingId,
  feedback,
  onLike,
  onDislike,
  extension,
}: FeedFooterProps) {
  const t = useTranslations();
  return (
    <AIFooter
      data={data}
      requestId={requestId}
      content={content}
      configType={IMConfigTypeEnum.generalFAQ}
      streamingId={streamingId}
      onLike={onLike}
      onDislike={onDislike}
      showFooter
      showActions
      showCopy={!!content}
      showSatisfy={
        !!extension || (data as { aiFlag?: boolean }).aiFlag === true
      }
      statusType="normal"
      statusText={t.chat.AIProvided}
      feedback={feedback}
    />
  );
}
